import {formatDate} from "../../../helpers/utils";

export const COMMON_REQ = 'cris/andon/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/andon/COMMON_REQ_FAIL';

export const LOAD_ANDONS_REQ = 'cris/user/LOAD_ANDONS_REQ';
export const LOAD_ANDONS_SUCCESS = 'cris/andon/LOAD_ANDONS_SUCCESS';

export const LOAD_FILTERED_ANDONS_SUCCESS = 'cris/user/LOAD_FILTERED_ANDONS_SUCCESS';

const initialState = {
	isLoading: false,
	isSearched: false,
	error: null,
    businessUnitsList: [],
    typesList: [],
    statusesList: [],
	andons: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

        case LOAD_ANDONS_REQ:
            return {
				...state,
				isLoading: true,
				isSearched: false,
				andons: []
			};

		case LOAD_ANDONS_SUCCESS:
			const businessUnitsList = action.payload.data.business_units.map(item => ({
				value: item.id,
				label: `${item.code} - ${item.name}`
			}));

		    const typesList = action.payload.data.types.map(item => ({
				value: item,
				label: item
			}));

		    const statusesList =action.payload.data.statuses.map(item => ({
				value: item,
				label: item
			}));

		    return {
				...state,
				isLoading: false,
				businessUnitsList: businessUnitsList,
                typesList: typesList,
                statusesList: statusesList
			};

        case LOAD_FILTERED_ANDONS_SUCCESS:
			const andons = action.payload.data.andons.map((item) => ({
				id: item.id,
				business_unit_id: item.business_unit_id,
				name: item.name,
				type: item.type,
				number: item.number || '',
				issue	: item.issue,
				status: item.status,
				created_by: item.created_by || '',
				created_at: item.created_at || '',
				resolved_by: item.resolved_by || '',
				resolved_at: item.resolved_at || '',

				businessUnitName: item.business_unit.name,
				createdBy: item.Creator ? item.Creator.name : '',
				formattedCreatedAt: item.created_at ? formatDate(item.created_at) : '',
				resolvedBy: item.Resolver ? item.Resolver.name : '',
				formattedResolvedAt: item.resolved_at ? formatDate(item.resolved_at) : '',
			}));

			return {
				...state,
				isLoading: false,
				isSearched: true,
				andons: andons
			};

		default:
			return state;
	}
}
